import React, { Component } from "react"

import "shared/base.scss"
import "./app.scss"

const getWindowHeight = () => {
  return (
    (document &&
      document.documentElement &&
      document.documentElement.clientHeight) ||
    window.innerHeight
  )
}

export default class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      style: {
        height: '100vh'
      }
    }  
  }

  updateStyle() {
    this.setState({
      style: {
        height: `${getWindowHeight()}px`
      }
    })
  }

  componentDidMount() {
    this.updateStyle()
    window.addEventListener('resize', () => { this.updateStyle() })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateStyle)
  }

  render() {
    return (
      <div className="c-App" style={this.state.style}>
        {this.props.children}
      </div>
    )
  }
}